<template>
        <div class="flex flex-col bg-white my-8 mx-6 px-8 py-12 gap-6">
            <h1 class="text-2xl font-bold pb-2">運営からのお知らせ</h1>
            <h2 class="border-b border-solid border-gray-300 py-4 font-bold text-xl">
                {{ title }}
            </h2>
            <span class="text-xs">{{ start_datetime }}</span>
            <span class="text-sm hyper-link" v-html="formatBody(body)"></span>
        </div>
</template>


<script setup>
    import { ref, onMounted }  from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import store from '../store';

    const route = useRoute();
    const router = useRouter();
    const title = ref("");
    const body = ref("");
    const start_datetime = ref("");

    onMounted(() => {
        fetchInformationDetails();
    });

    const fetchInformationDetails = () => {
        const accessToken = store.state.accessToken;
        const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
        let postData = {
            action: 'details',
            information_id: route.params.id
        };
        axios.post(`${apiEndpoint}/informations/`, postData,{
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        }).then(response => {
            const data = response.data.informationDetails;
            title.value = data.title;
            body.value = data.body;
            start_datetime.value = data.start_datetime;
        })
        .catch(error => {
            if (error.response && error.response.status === 404) {
                router.push({ name: 'NotFound' });
            } else {
                console.log(error);
            }
        });
    }

    const formatBody = (content) => {
        var body = content.replace(/\n/g, '<br>');
        body = body.replace(/<\/a><br><br>/g, '</a>');
        return body
    }

</script>

<style>
.hyper-link a{
    color: #2563EB;
    overflow-wrap: anywhere;
}
</style>
